export default __webpack_public_path__ + "be05e6e26f157ce353b3fa7980658e6f.png";